import { Directive, TemplateRef, Input, ViewContainerRef } from '@angular/core';
import { AuthorizationService } from '../services/index';
import { IUserAccessPermissions } from '../models';

@Directive({
    selector: '[appHideByAccess]',
    standalone: false
})
export class HideByAccessDirective {

  private permitted: boolean;
  accessPermissions: IUserAccessPermissions;

  constructor (private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authorizationService: AuthorizationService) {
  }

  @Input() set appHideByAccess(permission: string) {

    this.permitted = this.authorizationService.hasPermission(permission);

    if (this.permitted) {

      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}

